import { createPlugin } from "zudoku";

const requestIdleCallbackPolyfillScript = `
(() => {
  if (typeof globalThis === "undefined") {
    return;
  }

  const root = globalThis;

  if (typeof root.requestIdleCallback !== "function") {
    const requestIdleCallbackImpl = function (callback) {
      const start = Date.now();
      return root.setTimeout(function () {
        callback({
          didTimeout: false,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    };

    root.requestIdleCallback = requestIdleCallbackImpl;
    try {
      globalThis.eval?.("var requestIdleCallback = globalThis.requestIdleCallback;");
    } catch {}
  }

  if (typeof root.cancelIdleCallback !== "function") {
    const cancelIdleCallbackImpl = function (id) {
      root.clearTimeout(id);
    };

    root.cancelIdleCallback = cancelIdleCallbackImpl;
    try {
      globalThis.eval?.("var cancelIdleCallback = globalThis.cancelIdleCallback;");
    } catch {}
  }

  if (typeof requestIdleCallback === "undefined") {
    try {
      globalThis.eval?.("var requestIdleCallback = globalThis.requestIdleCallback;");
    } catch {}
  }

  if (typeof cancelIdleCallback === "undefined") {
    try {
      globalThis.eval?.("var cancelIdleCallback = globalThis.cancelIdleCallback;");
    } catch {}
  }
})();
`;

const requestIdleCallbackPolyfill = createPlugin(() => ({
  getHead: () => (
    <script
      id="request-idle-callback-polyfill"
      dangerouslySetInnerHTML={{ __html: requestIdleCallbackPolyfillScript }}
    />
  ),
}));

export default requestIdleCallbackPolyfill;
